import React from "react";
import { FormattedMessage } from "react-intl";
import SharedText from "../../../shared/SharedText/SharedText";
import "./track.scss";
const Track = () => {
  return (
    <div className="mobile-track">
      <div className="left">
        <div className="img" data-aos="fade-right" />
      </div>

      <div className="right">
        <SharedText
          title1={
            <FormattedMessage
              id="mobile-track-title"
              defaultMessage="Track your activities"
            />
          }
          text1={
            <FormattedMessage
              id="mobile-track-text"
              defaultMessage="Track your activities and drill down your stats by Date, Hour, Channel, Country, Visits, OS, Browser, Source, Revenue, Leads, CR%, RPM and more. Monitor KPI’s and track your monetization with our innovative ad formats."
            />
          }
        />
      </div>
    </div>
  );
};

export default Track;
